const config = {
    // Nama Aplikasi
    appName: "Nexus Community Hub",
    developer: "Rony Saputra",

    // URL API (Jika nanti kamu pakai backend/database)
    // Ubah ke URL hosting kamu jika sudah online
    apiUrl: process.env.REACT_APP_API_URL || "http://localhost:5000/api",

    // Konfigurasi Tema Warna (Nexus Theme)
    theme: {
        primary: "#00d2ff",   // Cyan
        secondary: "#00ff88", // Green (Community)
        background: "#070707",
        cardBg: "#0a0a0a",
        textMain: "#ffffff",
        textMuted: "#888888"
    },

    // Versi Aplikasi
    version: "2.1.0",
};

export default config;